import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { request } from "../core/api.client";

export interface IBajajUpiVpaLookupResponse {
  primaryVpa: string;
}

export const getBajajUpiVpa = async (): Promise<string | boolean> => {
  try {
    const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
    const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
    const response = await request<IBajajUpiVpaLookupResponse>({
      method: "POST",
      url: API_PATHS.vpaLookup,
      data: {
        mobileNo,
      },
    });
    if (response && response.statusCode === 90) {
      return response.data.primaryVpa;
    }
    return false;
  } catch (err) {
    return false;
  }
};
